import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { getUsersListing, inactiveUsers, deleteAccount } from "../../api/apiHandler";
import { showMessage, showErrorMessage } from "../common/Utils";
import $ from 'jquery';
// import 'magnific-popup/dist/jquery.magnific-popup.min.css';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function Userlisting() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    let navigate = useNavigate();
    const auth = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');

    // Redirect to login if not logged in
    if (!auth) {
        navigate('/login');
    }

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const userReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
            }
            console.log("REQUEST : ", userReq);
            const response = await getUsersListing(userReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading users listing, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        $('.image-popup').magnificPopup({
            type: 'image',
            gallery: {
              enabled: true
            }
        });
        fetchData();
    }, [pagination, search, sortField, sortOrder]);
    
    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const handleOnChangeEvent = async (e) => {

        try {
            let status = e.target.dataset.status === '1' ? 0 : 1;
            let userId = e.target.dataset.userid;
            let txtStatus = e.target.dataset.status === '1' ? 'active' : 'inactive';

            // Show confirmation dialog
            const result = await Swal.fire({
                title: "",
                text: `Are you sure you want to ${txtStatus} this user?`,
                imageUrl: process.env.PUBLIC_URL + '/logo.png',
                imageSize: '80x80',
                showCancelButton: true,
                confirmButtonColor: "#B6A878",
                cancelButtonColor: "#d33",
                confirmButtonText: e.target.dataset.status === '1' ? "Active" : "Inactive",
            });
            if (result.isConfirmed) {
                const updUsers = {
                    status: status,
                    user_id: userId,
                    token: '',
                    device_token: ''
                }
                console.log("REQUEST : ", updUsers);
                const response = await inactiveUsers(updUsers);
                if (parseInt(response.code) === 1) {
                    showMessage(response.message);
                    fetchData();
                } else {
                    showErrorMessage(response.message);
                }
            }
        } catch (error) {
            showErrorMessage("An unexpected error occurred inactivating/activating record!");
        }
    };

    const showDeleteConfirmation = async (user_id) => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: "",
                text: "Are you sure you want to delete this user? It can't be reverted back!",
                imageUrl: process.env.PUBLIC_URL + '/logo.png',
                imageSize: '80x80',
                showCancelButton: true,
                confirmButtonColor: "#B6A878",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
            });
            
            if (result.isConfirmed) {

                const updUsers = {
                    is_deleted: true,
                    user_id: user_id
                }

                console.log("REQUEST : ", updUsers);
                const response = await deleteAccount(updUsers);
                if (parseInt(response.code) === 1) {
                    showMessage(response.message);
                    fetchData();
                } else {
                    showErrorMessage(response.message);
                }
            }
        } catch (error) {
            showErrorMessage("An unexpected error occurred deleting record!");
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Users Listing</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Users Listing</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div></div>
                                            <div style={{ position: "relative", maxWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="🔍 Search..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px 15px",
                                                        borderRadius: "25px",
                                                        border: "1px solid #ccc",
                                                        outline: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "14px",
                                                    }}
                                                    className="form-control mb-3"
                                                />
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                { 
                                                    name: "PROFILE", 
                                                    selector: (row) => (
                                                        <a href={row.profile_image} className="image-popup">
                                                            <img 
                                                                src={row.profile_image} 
                                                                alt="Profile" 
                                                                className="img-responsive img-circle img-thumbnail"
                                                                height={50}
                                                                width={50}
                                                            />
                                                        </a>
                                                    ),
                                                    sortable: false,
                                                    width: '7%'
                                                },
                                                { name: "ACC. CODE", selector: (row) => row.account_code, sortable: true, sortableField: "account_code", width: '12%' },
                                                { name: "SYNTEL-UID", selector: (row) => (row.syntel_uid) ? <label class="label label-success">{row.syntel_uid}</label> : <label class="label label-warning">Pending</label>, sortable: true, sortableField: "syntel_uid", width: '12%' },
                                                { name: "FIRST NAME", selector: (row) => row.first_name, sortable: true, sortableField: "first_name", width: '12%' },
                                                { name: "LAST NAME", selector: (row) => row.last_name, sortable: true, sortableField: "last_name", width: '10%' },
                                                { name: "EMAIL", selector: (row) => row.email, sortable: false, width: '20%' },
                                                { name: "PHONE NUMBER", selector: (row) => `${row.country_code} ${row.phone}`, sortable: false, width: '12%' },
                                                { name: "KYC STATUS", selector: (row) => row.is_kyc_completed ? <label class="label label-success">Approved</label> : <label class="label label-danger">Not Done</label>, sortable: true, sortableField: "is_kyc_completed", width: '12%' },
                                                { 
                                                    name: "STATUS", 
                                                    selector: (row) => (
                                                        <div className="switch">
                                                            <label>
                                                                <input type="checkbox" name="changestatus" data-userid={row.id} data-status={row.status} checked={row.status === 0} onChange={handleOnChangeEvent} />
                                                                <span className="lever switch-col-green"></span>
                                                            </label>
                                                        </div>
                                                    ),
                                                    sortable: true,
                                                    sortableField: "status",
                                                    width: '8%'
                                                },
                                                { 
                                                    name: "ACTIONS", 
                                                    selector: (row) => (
                                                        <>
                                                            <a
                                                                href="#"
                                                                onClick={() => showDeleteConfirmation(row.id)}
                                                                className="btn btn-xs waves-effect waves-float waves-green"
                                                                style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                            >
                                                                <i className="zmdi zmdi-delete" style={{ color: '#D7C9A1' }} />
                                                            </a>&nbsp;
                                                            <a
                                                                href={ `/authpanel/users/view/${btoa(row.id)}` }
                                                                className="btn btn-xs waves-effect waves-float waves-green"
                                                                style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                            >
                                                                <i className="zmdi zmdi-eye" style={{ color: '#D7C9A1' }} />
                                                            </a>
                                                        </>
                                                    ),
                                                    sortable: false,
                                                    width: '10%'
                                                },
                                            ]}
                                            data={data || []}
                                            defaultSortField="account_code"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={50} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}